<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href="route_back">Плейлисты</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Редактирование плейлиста</li>
        </ol>
    </nav>

    <div class="edit-pl">
        <div class="two-col-container">
            <div class="left-col">
                <div class="form-body edit-pl-form-body">
                    <div class="form-check mb-4">
                        <input class="form-check-input" type="checkbox" v-model="playlist_default">
                        <label class="form-check-label">
                            Дефолтный плейлист
                        </label>
                    </div>

                    <div class="mb-4">
                        <label for="playlist-name" class="form-label">
                            Клиент
                        </label>
                        <input type="text"
                               class="form-control"
                               disabled
                               v-model="client_name"
                               placeholder="Клиент">
                    </div>

                    <div class="mb-4">
                        <label for="playlist-name" class="form-label">
                            Бренд
                        </label>
                        <input type="text"
                               class="form-control"
                               disabled
                               v-model="brand_name"
                               placeholder="Бренд">
                    </div>

                    <div class="mb-4">
                        <label for="playlist-name" class="form-label">
                            Тип устройства
                        </label>
                        <input type="text"
                               class="form-control"
                               v-model="deviceType"
                               disabled
                               placeholder="Название">
                    </div>

                    <div class="mb-4">
                        <label for="playlist-name" class="form-label">
                            Название плейлиста
                        </label>
                        <input type="text" class="form-control"
                               ref="playlistName"
                               id="playlist-name"
                               v-model="name"
                               placeholder="Название">
                    </div>

                    <div class="d-flex-col justify-content-beetween mb-4">
                        <label for="playlist-interval" class="form-label">
                            Диапазон показа <span class="color-red">*</span>
                        </label>
                        <DateTimePicker id="playlist-interval"
                            :enableTimePicker="true"
                            :range="true"
                            :minDate="minDate"
                            :value="dateTime"
                            @updateValue="handleDateTime"
                        />
                    </div>

                    <div class="mb-4">
                        <div class="tabs mb-2">
                            <div class="tabs__ctrls">
                                <button class="reset-btn tabs__ctrl local" v-on:click.prevent="devices_by = 1"
                                        :class="{ 'is-selected': devices_by === 1 }" type="button">
                                    Устройства
                                </button>
                                <button class="reset-btn tabs__ctrl cloud" v-on:click.prevent="devices_by = 0"
                                        :class="{ 'is-selected': devices_by === 0 }" type="button">
                                    Группы устройств
                                </button>
                                <button class="reset-btn tabs__ctrl cloud" v-on:click.prevent="devices_by = 2"
                                        :class="{ 'is-selected': devices_by === 2 }" type="button">
                                    Регионы
                                </button>
                            </div>
                        </div>

                        <template v-if="devices_by === 0">
                            <div class="mb-4 mt-4">
                                <v-select
                                    v-model="group_ids"
                                    :items="groups"
                                    item-title="name"
                                    item-value="id"
                                    variant="outlined"
                                    color="primary"
                                    density="compact"
                                    clearable
                                    multiple>
                                    <template #no-data>
                                        <v-list-item>
                                            <span>Данные не найдены</span>
                                        </v-list-item>
                                    </template>
                                    <template #selection="{ item, index }">
                                        <v-chip v-if="index < 3" :text="item.title"></v-chip>
                                        <span v-if="index === 3" class="text-grey text-caption align-self-center">
                                            + еще {{ group_ids.length - 3 }}
                                        </span>
                                    </template>
                                </v-select>
                            </div>
                        </template>

                        <template v-if="devices_by === 1">
                            <div v-if="enableSync" class="mb-4 mt-4 tabs-content">
                                <select-back-searchable-element
                                    @getItems="loadDevices" @syncItems="syncDevices"
                                    :loaded_items="devices_founded"
                                    :picked_items="device_ids"
                                    :pages="devices_pages">
                                </select-back-searchable-element>
                            </div>
                        </template>

                        <template v-if="devices_by === 2">
                            <div class="mb-4 mt-4">
                                <!-- Если нужен единственный выбор - убрать multiple -->
                                <!-- <v-select class="searchable"
                                          multiple
                                          v-model="regions_ids"
                                          :reduce="name => name.id"
                                          label="name"
                                          :options="regions"
                                          :deselectFromDropdown="false"
                                          :close-on-select="false"
                                          :clearable="true">
                                    <template #no-options="{ search, searching, loading }">
                                        <div class="text-not-found">Не найдено</div>
                                    </template>
                                </v-select> -->
                                <v-select
                                    v-model="regions_ids"
                                    :items="regions"
                                    item-title="name"
                                    item-value="id"
                                    variant="outlined"
                                    color="primary"
                                    density="compact"
                                    clearable
                                    multiple>
                                    <template #no-data>
                                        <v-list-item>
                                            <span>Данные не найдены</span>
                                        </v-list-item>
                                    </template>
                                    <template #selection="{ item, index }">
                                        <v-chip v-if="index < 3" :text="item.title"></v-chip>
                                        <span v-if="index === 3" class="text-grey text-caption align-self-center">
                                            + еще {{ regions_ids.length - 3 }}
                                        </span>
                                    </template>
                                </v-select>
                            </div>
                        </template>

                        <div v-if="deviceType == cashier_type_id" class="mb-4">
                            <label class="form-label">Формат отображения(только для типа ус-в МК)</label>
                            <div v-for="format in playlist_display_formats" class="form-check">
                                <input v-model="playlist_display_format"
                                    :value="format.id"
                                    :checked="format.id === this.playlist_display_format"
                                    type="radio"
                                    class="form-check-input">
                                {{ format.name }}
                            </div>
                        </div>
                    </div>
                </div>

                <timeline-element
                    :contents="contents"
                    @contentDir="loadDir"
                    @syncContent="syncContent"
                    :playlist_content="playlist_content"
                    :itemsFromFolder="itemsFromFolder"
                    :opener="opener"
                    :domain="domain">
                </timeline-element>

                <div class="edit-pl-submit-wrap d-flex align-items-stretch py-3">
                    <ConfirmBtn :class="'btn btn-lg btn-primary me-3'" :text="'Сохранить'" @btnClick="updatePlaylist"/>
                    <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
                </div>
            </div>

            <Transition name="fade">
                <div v-if="showSelectedDevices" class="right-col">
                    <SelectedDevices
                        :devicesFounded="devices_founded"
                        :devicesTypeId="deviceTypeId"
                        v-model:addedDevicesIds="device_ids"
                        v-model:groupIds="group_ids"
                        v-model:regionIds="regions_ids"
                        @stateChange="handleSelectedDevicesState"
                    />
                </div>    
            </Transition>
        </div>
    </div>

    <Alert />
</template>

<script>

import Playlist from "../../../../models/Playlist"
import example from "../../../../data/example"
import TimelineElement from "../../../../elements/TimelineElement.vue";
import Content from "../../../../models/Content";
import SelectBackSearchableElement from "../../../../elements/SelectBackSearchableElement.vue";
import axios from 'axios'
import Alert from "../../../alerts/Alert.vue";
import { mapMutations } from "vuex/dist/vuex.cjs.js";
import ConfirmBtn from "../../../../elements/ConfirmBtn.vue";
import DateTimePicker from "../../../../elements/DateTimePicker.vue";
import SelectedDevices from "../../../../elements/SelectedDevices.vue";

export default {
    name: "PlaylistEditComponent",
    components: {
        SelectBackSearchableElement,
        TimelineElement,
        Alert,
        ConfirmBtn,
        DateTimePicker,
        SelectedDevices
    },
    props: {
        route_back: String,
        route_update: String,
        route_get: String,
        route_client_search: String,
        route_brand_search: String,
        route_device_groups_search: String,
        route_devices_search: String,
        route_content_list: String,
        route_dir_content: String,
        route_get_regions: String,
        cashier_type_id: Number,
        domain: String,
        playlist_id: {
            type: Number,
            default: 0
        }
    },
    data: function () {
        return {
            playlist: new Playlist({
                route_update: this.route_update,
                route_get: this.route_get,
                route_brand_search: this.route_brand_search,
                route_client_search: this.route_client_search,
                route_device_groups_search: this.route_device_groups_search,
                route_devices_search: this.route_devices_search
            }),
            content: new Content({
                route_list: this.route_content_list,
                route_dir_content: this.route_dir_content,
            }),
            device_sources: [
                {
                    id: 0,
                    label: 'Выбрать вручную'
                }
            ],
            device_source: 0,
            devices_by_sources: [
                {
                    id: 0,
                    label: 'Группы устройств'
                },
                {
                    id: 1,
                    label: 'Устройства'
                }
            ],
            playlist_display_formats: [
                {
                    id: 1,
                    name: 'Вертикальный'
                },
                {
                    id: 2,
                    name: 'Горизонтальный'
                }
            ],
            dateTime: [],
            minDate: new Date().toISOString().split('T')[0],
            playlist_display_format: '',
            devices_by: 0,
            client_id: 0,
            client_name: '',
            brand_id: 0,
            brand_name: '',
            deviceType: null,
            deviceTypeId: null,
            example,
            name: '',
            start: '',
            end: '',
            time_start: '',
            time_end: '',
            groups: [],
            group_ids: [],
            device_ids: [],
            regions: [],
            regions_ids: [],
            playlist_default: false,
            contents: [],
            playlist_content: [],
            device_ids_new: [],
            enableSync: true,
            content_changed: false,
            devices_changed: false,
            devices_founded: [],
            devices_pages: 1,
            itemsFromFolder: [],
            opener: '',
            showSelectedDevices: false,
        }
    },
    computed: {
        devicesSelected() {
            if (this.device_ids.length || this.group_ids.length || this.regions_ids.length) return true;
            else return false;
        }
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        ...mapMutations('ui', ['toggleLoading']),
        syncDevices: function (devices) {
            if (this.enableSync) {
                this.device_ids = devices;
                this.device_ids_new = devices;
                this.devices_changed = true;
            }
        },
        loadDevices: async function (search, limit, page) {
            let data = await this.playlist.devices({
                search: search,
                limit: limit,
                page: page,
                client_id: this.client_id,
                brand_id: this.brand_id
            });
            this.devices_founded = data.items;
            this.devices_pages = data.pages;
        },
        syncContent: function (list) {
            if (this.enableSync) {
                this.playlist_content = list;
                this.content_changed = true;
            }
        },
        getContent: async function () {
            let response = await this.content.loadTable(1, 1000, '', {
                client_id: this.client_id,
                brand_id: this.brand_id
            });
            this.contents = response.items;
        },
        getRegions: async function () {
            let data = await axios.get(this.route_get_regions, {
                params: {
                    limit: 9999
                }
            });
            this.regions = data.data.items;
        },
        loadDir: async function (item) {
            if (item.type == 2) {
                let result = await this.content.loadDir(item.id);
                item.content = result.items;
                this.itemsFromFolder = item.content
                return result
            }
        },
        searchGroups: async function () {
            await this.playlist.deviceGroups({
                client_id: this.client_id,
                brand_id: this.brand_id,
                device_type_id: this.deviceTypeId,
            })
            .then(result => {
                this.groups = result.items;
                let formatedIds = [];
                this.group_ids.forEach(id => {
                    formatedIds.push(
                        this.groups.find(group => group.id === id)
                    )
                });
            });
        },
        dateFormat: (date, displayTime = false) => {
            if (typeof date === 'string') {
                return date.replace(/(\d{4})-(\d{2})-(\d{2})(?:\s|T)([\d\:]+).*/, '$1-$2-$3' + (displayTime ? ' $4' : ''))
            }
            return ''
        },
        itemGet: async function () {
            let item = await this.playlist.get(this.playlist_id);
            this.name = item.playlist.name;
            this.deviceType = item.playlist.device_type_name;
            this.deviceTypeId = item.playlist.device_type_id;
            this.playlist_default = item.playlist.default === 1;
            // this.start = this.dateFormat(item.playlist.start);
            // this.end = this.dateFormat(item.playlist.end);
            // this.time_start = item.playlist.time_start;
            // this.time_end = item.playlist.time_end;
            this.client_id = item.playlist.client_id;
            this.client_name = item.playlist.client_name;
            this.brand_id = item.playlist.brand_id;
            this.brand_name = item.playlist.brand.name;
            this.group_ids = item.groups;
            this.device_ids = item.playlist.devices;
            this.playlist_display_format = item.playlist.display_format;

            this.setDateTimePickerValue([item.playlist.start, item.playlist.end]);

            item.playlist.regions.forEach(region => {
                this.regions_ids.push(region.id);
            });

            if (this.device_ids.length > 0) {
                this.devices_by = 1;
            }

            if (this.regions_ids.length > 0) {
                this.devices_by = 2;
            }

            item.playlist.contents.forEach((item) => {
                let arrayDuration = item.duration.split(":");
                let duration = (parseInt(arrayDuration[0], 10) * 60 * 60) + (parseInt(arrayDuration[1], 10) * 60) + parseInt(arrayDuration[2], 10);
                this.playlist_content.push({
                    id: item.id,
                    source: item.path,
                    length: duration,
                    thumb: (item.type_id === 1) ? item.path : item.frame_path,
                    poster: (item.type_id === 1) ? item.path : item.frame_path,
                    width: 10,
                    name: item.name
                });
            });
            await this.getContent();
            await this.searchGroups();
            await this.loadDevices('', 9999, 1);
            this.enableSync = true;
        },
        updatePlaylist: async function () {
            if (this.$refs.playlistName.value === '') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Введите название плейлиста!' });
                this.toggleLoading();
                return;
            }

            if (this.group_ids[0] === undefined &&
                this.regions_ids[0] === undefined &&
                (this.device_ids[0] === undefined && this.device_ids_new[0] === undefined)
            ) {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Добавьте хотя бы одно устройство, группу или регион!' });
                this.toggleLoading();
                return;
            }

            let params = {
                name: this.name,
                start: this.start,
                end: this.end,
                default: this.playlist_default,
                time_start: this.time_start,
                time_end: this.time_end,
                groups_ids: this.group_ids,
                playlist_display_format: this.playlist_display_format,
                region_ids: this.regions_ids
            };

            if (this.content_changed) {
                params.contents = this.playlist_content;
            }
            if (this.devices_changed) {
                params.device_ids = this.device_ids_new;
            }
            if (this.devices_by === 0) {
                params.device_ids = [];
            } else {
                params.groups_ids = [];
            }
            let result = await this.playlist.update(params, this.playlist_id)
            if (result) {
                window.location.href = this.route_back
            } else {
                this.addAlert({ type: 'error', title: 'Ошибка', text: window.lastResponse.data.message });
                this.toggleLoading();
            }
        },
        interceptResponse() {
            window.lastResponse = null;
            axios.interceptors.response.use(response => {
                window.lastResponse = response;
                return response;
            }, error => {
                window.lastResponse = error.response;
                return Promise.reject(error);
            });
        },
        handleDateTime(value) { // обработка данных из DateTimePicker
            this.start = value.date.start;
            this.end = value.date.end;
            this.time_start = value.time.start;
            this.time_end = value.time.end;
        },
        setDateTimePickerValue(date) {
            date.forEach(element => {
                this.dateTime.push(element);
            });
        },
        handleSelectedDevicesState(state) {
            this.showSelectedDevices = state;
        }
    },
    watch: {
        devicesSelected: {
            handler(val) {
                if (val) {
                    this.showSelectedDevices = true;
                }
            },
        }
    },
    mounted () {
        this.itemGet();
        this.interceptResponse();
        this.getRegions();
    },
}
</script>

<style scoped>
    .pl-video-preview {
        display: flex;
        position: relative;
        overflow: hidden;
        line-height: 1;
        width: 100%;
        max-height: 350px;
        border-radius: 5px;
        background-color: #575F6E;
    }

    .content-list {
        max-height: 343px;
        height: auto;
        overflow-y: auto;
        padding-right: 24px;
    }
    .tabs-content > * {
        margin-top: 0 !important;
        margin-bottom:0 !important;
    }
</style>
